import React, { useState } from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';
import '../../styles/CustomModal.css';
import { PRODUCT_TYPE_DELIVERY } from '../../controller/OrderController';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  type: string;
  setType: (type: string) => void;
  setVisibleConfirm: () => void;
  orderCategory: number;
};

const RejectModal = ({
  isVisible,
  setVisible,
  type,
  setType,
  setVisibleConfirm,
  orderCategory,
}: Props) => {
  const [cancelText, setCancelText] = useState<string>('');

  const onCloseModal = () => {
    setVisible(false);
  };

  const focusInput = () => {
    setType(cancelText);
  };

  const onSubmit = () => {
    setType(cancelText);
    setVisibleConfirm();
  };

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: 'rejectModalOverlay',
        modal: 'rejectModal',
        root: 'customModalRoot',
      }}
      showCloseIcon={true}
      animationDuration={150}>
      <Style>
        <div className="modal">
          <div className="headerBar" />
          <h2>주문 취소 사유</h2>
          <div className="listWrap">
            {orderCategory === PRODUCT_TYPE_DELIVERY && (
              <>
                <button
                  className={`typeBox ${type === '가게 사정' && 'active'}`}
                  onClick={() => setType('가게 사정')}>
                  가게 사정
                </button>
                <button
                  className={`typeBox ${type === '조리 지연' && 'active'}`}
                  onClick={() => setType('조리 지연')}>
                  조리 지연
                </button>
                <button
                  className={`typeBox ${type === '요청사항\n적용불가' && 'active'}`}
                  onClick={() => setType('요청사항\n적용불가')}>
                  {`요청사항\n적용 불가`}
                </button>
                <button
                  className={`typeBox ${type === '배달원 부재' && 'active'}`}
                  onClick={() => setType('배달원 부재')}>
                  배달원 부재
                </button>
                <button
                  className={`typeBox ${type === '재료 소진' && 'active'}`}
                  onClick={() => setType('재료 소진')}>
                  재료 소진
                </button>
                <button
                  className={`typeBox ${type === '고객 요청' && 'active'}`}
                  onClick={() => setType('고객 요청')}>
                  고객 요청
                </button>
              </>
            )}
          </div>
          <input
            value={cancelText}
            placeholder="주문취소 사유를 직접 입력해주세요"
            onChange={(e) => setCancelText(e.target.value)}
            onFocus={focusInput}
          />
          <div className="row gap">
            <button onClick={onSubmit}>완료</button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default RejectModal;

const Style = styled.div`
  .modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 7% 12% 5% 12%;
  }

  .headerBar {
    width: 44px;
    height: 5px;
    margin: 0 auto;
    border-radius: 10px;
    background: #4dd2ae;
  }

  h2 {
    margin-top: 22px;
    color: #333333;
    font-weight: 500;
    text-align: center;
  }

  .listWrap {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: 24px 0 1%;

    .typeBox {
      width: calc(94% / 3);
      height: 90px;
      border: 1px solid #a7a7a7;
      border-radius: 10px;
      margin: 1%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      line-height: 24px;
      font-weight: 500;
      color: #333333;
      white-space: pre-line;
    }
    .typeBox.active {
      background: #ecf7f4;
      color: #4dd2ae;
      border: 1px solid #4dd2ae;
    }
  }

  input {
    width: 98%;
    border-radius: 10px;
    border: 1px solid #a7a7a7;
    padding: 8px 30px;
    font-size: 20px;
    line-height: 24px;
    background: #efefef;
    font-weight: 400;
    margin-bottom: 20px;
  }
  input::placeholder {
    color: #d2d2d2;
  }

  .row.gap {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    button {
      flex: 1;
      text-align: center;
      background: #4dd2ae;
      border: 1px solid #4dd2ae;
      border-radius: 10px;
      padding: 12px 0;
      font-size: 24px;
      line-height: 30px;
      font-weight: 600;
      color: #ffffff;
    }
  }

  @media (max-width: 900px) {
    .modal {
      padding: 40px 12px;
    }

    h2 {
      font-size: 20px;
    }

    .listWrap {
      .typeBox {
        font-size: 18px;
      }
    }

    input {
      padding: 8px 20px;
      font-size: 16px;
      line-height: 20px;
      margin-top: 8px;
      margin-bottom: 20px;
    }
  }
`;
